import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
// import { Clock, DollarSign, Shield } from "lucide-react"
import styles from "./features-carousel.module.scss";
import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import secondaryFont from "@/utils/secondaryFont";

const slides = [
  {
    // icon: <Clock className={styles.icon} />,
    title: "Expert Appraisals",
    description:
      "Our team consists of certified appraisers with in-depth knowledge of Rolex models, vintage timepieces, and limited editions. We assess every detail to provide a fair and honest appraisal.",
  },
  {
    // icon: <DollarSign className={styles.icon} />,
    title: "Top Dollar Offers",
    description:
      "Thanks to our extensive network of collectors and buyers, we're able to make higher offers than traditional jewelers or pawn shops.",
  },
  {
    // icon: <Shield className={styles.icon} />,
    title: "No-Pressure Environment",
    description:
      "Get a free, no-obligation appraisal. Whether you choose to sell or not, we're here to provide the information and ensure your comfort.",
  },
  {
    // icon: <Shield className={styles.icon} />,
    title: "No-Pressure Environment",
    description:
      "Get a free, no-obligation appraisal. Whether you choose to sell or not, we're here to provide the information and ensure your comfort.",
  },
  {
    // icon: <Shield className={styles.icon} />,
    title: "No-Pressure Environment",
    description:
      "Get a free, no-obligation appraisal. Whether you choose to sell or not, we're here to provide the information and ensure your comfort.",
  },
];

export default function FeaturesCarousel({ data }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
    skipSnaps: false,
    dragFree: false,
  });
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  const scrollTo = useCallback(
    (index) => emblaApi && emblaApi.scrollTo(index),
    [emblaApi],
  );

  const onInit = useCallback((emblaApi) => {
    setScrollSnaps(emblaApi.scrollSnapList());
  }, []);

  const onSelect = useCallback((emblaApi) => {
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onInit(emblaApi);
    onSelect(emblaApi);
    emblaApi.on("reInit", onInit);
    emblaApi.on("select", onSelect);
  }, [emblaApi, onInit, onSelect]);

  return (
    <section
      className={`${styles.carousel}  ${data?.features_grey_bg ? "grey-bg" : ""}`}
    >
      <div className={styles.container}>
        <div className={styles.heading_wrapper}>
          <div className={styles.heading}>
            <PrismicRichText field={data.feature_section_title} />
          </div>
          {data?.features_description?.length > 0 && (
            <div className={`${secondaryFont} mt-2 text-center`}>
              <PrismicRichText field={data?.features_description || []} />
            </div>
          )}
        </div>

        <div className={styles.embla} ref={emblaRef}>
          <div className={styles.emblaContainer}>
            {data.cards &&
              data.cards.map((slide, index) => (
                <div className={styles.emblaSlide} key={index}>
                  <div className={styles.slideContent}>
                    <div className={styles.slideInner}>
                      <div className={styles.iconWrapper}>
                        <PrismicNextImage field={slide.icon} fallbackAlt="" />
                      </div>
                      <div className={styles.slideTitle}>
                        <PrismicRichText field={slide.title} />
                      </div>
                      <div className={styles.slideDescription}>
                        <PrismicRichText field={slide.description} />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className={styles.emblaDots}>
          {scrollSnaps.map((_, index) => (
            <button
              key={index}
              className={`${styles.emblaDot} ${index === selectedIndex ? styles.emblaDotSelected : ""}`}
              type="button"
              onClick={() => scrollTo(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
